import { AlertCircle } from '@tamagui/lucide-icons';
import { useTranslation } from 'react-i18next';
import { YStack, Text, XStack } from 'tamagui';
import { tokens } from 'tamagui-config';

import { TripleGlowBackground, GlowCircle } from '../../../components/common';
import { WaterWave } from '../../../components/common/WaterWave';
import { WidgetCardStatus, WidgetCardStatuses } from '../../../components/common/WidgetCardStatus';
import {
  useGetWaterQualityData,
  waterQualityColorTokens,
} from '../../../hooks/water/useGetWaterQualityData';

export const WaterQualityContent: React.FC = () => {
  const { t } = useTranslation();
  const data = useGetWaterQualityData();

  if (!data) {
    return <WidgetCardStatus status={WidgetCardStatuses.OFFLINE} />;
  }

  const { percentage, label, color, tds } = data;
  const { gradientStart, gradientEnd, backgroundGradients } = waterQualityColorTokens[color];

  const errorState = percentage < 0 || percentage > 100;
  const displayLabel = errorState ? t('common.sensorFault') : label;
  const displayTds = errorState ? '' : ` - ${tds} ppm`;

  if (errorState) {
    const radius = 120;
    const glowSize = radius * 2.5;

    return (
      <YStack alignItems="center" justifyContent="space-between" flex={1} position="relative">
        <GlowCircle
          size={glowSize}
          color={tokens.color.warningRed}
          stopOpacity={0.2}
          style={{
            position: 'absolute',
            top: -glowSize / 4,
            left: glowSize / 3,
          }}
        />
        <XStack
          alignItems="center"
          justifyContent="center"
          backgroundColor="rgba(255, 255, 255, 0.05)"
          borderRadius={radius}
          borderWidth={1}
          borderColor="rgba(255, 255, 255, 0.08)"
          padding={'$9'}>
          <AlertCircle color={tokens.color.warningRed} size={radius} />
        </XStack>
        <Text color="$color" fontSize="$9.5">
          {displayLabel}
        </Text>
      </YStack>
    );
  }

  return (
    <YStack alignItems="center" justifyContent="space-between" flex={1}>
      <TripleGlowBackground gradientColors={backgroundGradients} />
      <WaterWave
        percentage={percentage}
        radius={120}
        gradientStart={gradientStart}
        gradientEnd={gradientEnd}
      />
      <Text color="$color" fontSize="$9.5">
        {displayLabel}
        {displayTds}
      </Text>
    </YStack>
  );
};
